module.exports = __webpack_public_path__ + "img/GreekTechPodromos3_ua.928c4524.webp";